


































import Vue from 'vue'
import SmallMonthlyInvoiceEl from '@/components/elements/SmallMonthlyInvoiceEl.vue'
import ButtonEl from '@/components/elements/ButtonEl.vue'
import { SmallMonthlyInvoiceSummaryElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'SmallMonthlyInvoiceSummaryEl',
  components: {
    SmallMonthlyInvoiceEl,
    ButtonEl
  },
  props: {
    templateItemData: {
      type: Object as () => SmallMonthlyInvoiceSummaryElInterface,
      required: true
    }
  }
})
